export default {
  LOAD_EVENT_OVERVIEW_PAGE_START: 'LoadGeneralCompetencyEventOverviewPageStart',
  LOAD_EVENT_OVERVIEW_PAGE_END: 'LoadGeneralCompetencyEventOverviewPageEnd',
  SELECT_EVENT_OVERVIEW_PAGE_TAB: 'SelectGeneralCompetencyEventOverviewPageTab',
  CHANGE_EVENT_STATUS_START: 'ChangeGeneralCompetencyEventStatusStart',
  CHANGE_EVENT_STATUS_END: 'ChangeGeneralCompetencyEventStatusEnd',
  TOGGLE_EVENT_OVERVIEW_CONFIRM_DIALOG: 'ToggleGeneralCompetencyEventOverviewConfirmDialog'
};
